import React from 'react';
import Marquee from 'react-fast-marquee';

import * as partners from '~/assets/images/partners';

type Props = {};

const Partners: React.FC<Props> = () => {
  return (
    <section className="partners" id="partners">
      <div className="partners-wrap">
        <div className="partners-list">
          <Marquee style={{ overflowY: 'hidden' }} speed={30}>
            <ul>
              <li data-id="1" data-isShow="1">
                <img src={partners.ZeroOnenodePng} alt="01node" />
              </li>
              <li data-id="2" data-isShow="1">
                <img src={partners.ZeroXAndPng} alt="0x&" />
              </li>
              <li data-id="3" data-isShow="1">
                <img src={partners.AgnitioFZEPng} alt="Agnitio FZE" />
              </li>
              <li data-id="4" data-isShow="1">
                <img src={partners.AlgorithPng} alt="Algorith" />
              </li>
              <li data-id="5" data-isShow="1">
                <img src={partners.allmPng} alt="allm" />
              </li>
              <li data-id="6" data-isShow="1">
                <img src={partners.AnimocaBrandsPng} alt="Animoca Brands" />
              </li>
              <li data-id="7" data-isShow="1">
                <img src={partners.AnkrPng} alt="Ankr" />
              </li>
              <li data-id="8" data-isShow="1">
                <img src={partners.AxelarPng} alt="Axelar" />
              </li>
              <li data-id="9" data-isShow="1">
                <img src={partners.BHarvestPng} alt="B-Harvest" />
              </li>
              <li data-id="10" data-isShow="1">
                <img
                  src={partners.BCWVenturesLimitedPng}
                  alt="BCW Ventures Limited"
                />
              </li>
              <li data-id="11" data-isShow="1">
                <img
                  src={partners.BIGBrainHoldingsPng}
                  alt="BIG Brain Holdings"
                />
              </li>
              <li data-id="12" data-isShow="1">
                <img
                  src={partners.BlockchainCoinvestorsPng}
                  alt="Blockchain Coinvestors"
                />
              </li>
              <li data-id="13" data-isShow="1">
                <img src={partners.BlockdaemonPng} alt="Blockdaemon" />
              </li>
              <li data-id="14" data-isShow="0">
                <img src={partners.Bit2MeProPng} alt="Bit2Me Pro" />
              </li>
              <li data-id="15" data-isShow="0">
                <img src={partners.BithumbPng} alt="Bithumb" />
              </li>
              <li data-id="16" data-isShow="0">
                <img src={partners.BitMEXPng} alt="BitMEX" />
              </li>
              <li data-id="17" data-isShow="1">
                <img src={partners.BPMGPng} alt="BPMG" />
              </li>
              <li data-id="18" data-isShow="1">
                <img src={partners.BwareLabsPng} alt="BwareLabs" />
              </li>
              <li data-id="19" data-isShow="1">
                <img src={partners.CarbonatedPng} alt="Carbonated" />
              </li>
              <li data-id="20" data-isShow="1">
                <img src={partners.CertikPng} alt="Certik" />
              </li>
              <li data-id="21" data-isShow="0">
                <img src={partners.ChainapsisPng} alt="Chainapsis" />
              </li>
              <li data-id="22" data-isShow="1">
                <img src={partners.ChainLayerPng} alt="ChainLayer" />
              </li>
              <li data-id="23" data-isShow="1">
                <img src={partners.ChainodeTechPng} alt="Chainode Tech" />
              </li>
              <li data-id="24" data-isShow="1">
                <img src={partners.ChorusonePng} alt="Chorus one" />
              </li>
              <li data-id="25" data-isShow="0">
                <img src={partners.CoinEXPng} alt="CoinEX" />
              </li>
              <li data-id="26" data-isShow="1">
                <img src={partners.Com2uSPng} alt="Com2uS" />
              </li>
              <li data-id="27" data-isShow="1">
                <img src={partners.Com2uSHoldingsPng} alt="Com2uS Holdings" />
              </li>
              <li data-id="28" data-isShow="1">
                <img src={partners.Com2uSPlatformPng} alt="Com2uS Platform" />
              </li>
              <li data-id="29" data-isShow="1">
                <img
                  src={partners.ConceptArtHouseIncPng}
                  alt="Concept Art House, Inc."
                />
              </li>
              <li data-id="30" data-isShow="0">
                <img
                  src={partners.ConsensysFormationPng}
                  alt="Consensys Formation"
                />
              </li>
              <li data-id="31" data-isShow="1">
                <img src={partners.CosmostationPng} alt="Cosmostation" />
              </li>
              <li data-id="32" data-isShow="1">
                <img src={partners.CrosseanglePng} alt="Crosseangle" />
              </li>
              <li data-id="33" data-isShow="1">
                <img src={partners.CrossnodeLabsPng} alt="Crossnode Labs" />
              </li>
              <li data-id="34" data-isShow="1">
                <img src={partners.CryptocomPng} alt="Crypto.com" />
              </li>
              <li data-id="35" data-isShow="0">
                <img src={partners.DAERISOFTPng} alt="DAERISOFT" />
              </li>
            </ul>
          </Marquee>
        </div>

        <div className="partners-list">
          <Marquee
            style={{ overflowY: 'hidden' }}
            direction="right"
            speed={25}
            autoFill
          >
            <ul>
              <li data-id="36" data-isShow="1">
                <img src={partners.DelightPng} alt="Delight" />
              </li>
              <li data-id="37" data-isShow="1">
                <img src={partners.DexlabPng} alt="Dexlab" />
              </li>
              <li data-id="38" data-isShow="1">
                <img src={partners.DreamLaddersPng} alt="DreamLadders" />
              </li>
              <li data-id="39" data-isShow="1">
                <img src={partners.EventLabsPng} alt="Event Labs" />
              </li>
              <li data-id="40" data-isShow="1">
                <img src={partners.EverstakePng} alt="Everstake" />
              </li>
              <li data-id="41" data-isShow="1">
                <img src={partners.FiretreePng} alt="Firetree" />
              </li>
              <li data-id="42" data-isShow="1">
                <img src={partners.ForbolePng} alt="Forbole" />
              </li>
              <li data-id="43" data-isShow="1">
                <img
                  src={partners.FormlessCapitalInternationalLimitedPng}
                  alt=""
                />
              </li>
              <li data-id="44" data-isShow="1">
                <img src={partners.FUNFLOWPng} alt="FUNFLOW" />
              </li>
              <li data-id="45" data-isShow="0">
                <img src={partners.GateioPng} alt="Gate.io" />
              </li>
              <li data-id="46" data-isShow="1">
                <img
                  src={partners.GalaxyInteractiveFundILPPng}
                  alt="Galaxy Interactive Fund I LP"
                />
              </li>
              <li data-id="47" data-isShow="1">
                <img src={partners.Gall3ryPng} alt="Gall3ry" />
              </li>
              <li data-id="48" data-isShow="1">
                <img
                  src={partners.GoalVenturePartnersILLCPng}
                  alt="Goal Venture Partners I, LLC"
                />
              </li>
              <li data-id="49" data-isShow="1">
                <img src={partners.GomblePng} alt="Gomble" />
              </li>
              <li data-id="50" data-isShow="0">
                <img src={partners.GoogleCloudPng} alt="Google Cloud" />
              </li>
              <li data-id="51" data-isShow="0">
                <img src={partners.GOPAXPng} alt="GOPAX" />
              </li>
              <li data-id="52" data-isShow="1">
                <img src={partners.gumiPng} alt="gumi" />
              </li>
              <li data-id="53" data-isShow="1">
                <img src={partners.HallidayPng} alt="Halliday" />
              </li>
              <li data-id="54" data-isShow="1">
                <img src={partners.HashedPng} alt="Hashed" />
              </li>
              <li data-id="55" data-isShow="1">
                <img src={partners.HashkeyCloudPng} alt="Hashkey Cloud" />
              </li>
              <li data-id="56" data-isShow="1">
                <img src={partners.HAVAHPng} alt="HAVAH" />
              </li>
              <li data-id="57" data-isShow="1">
                <img
                  src={partners.HivePlatformLabPng}
                  alt="Hive Platform Lab"
                />
              </li>
              <li data-id="58" data-isShow="1">
                <img
                  src={partners.HuobiInnovationLabsIncPng}
                  alt="Huobi Innovation Labs Inc."
                />
              </li>
              <li data-id="59" data-isShow="1">
                <img src={partners.HYPERCOMICPng} alt="HYPERCOMIC" />
              </li>
              <li data-id="60" data-isShow="1">
                <img
                  src={partners.InfinityVenturesPng}
                  alt="Infinity Ventures"
                />
              </li>
              <li data-id="61" data-isShow="1">
                <img src={partners.InotelPng} alt="Inotel" />
              </li>
              <li data-id="62" data-isShow="0">
                <img src={partners.IUPPITERPng} alt="IUPPITER" />
              </li>
              <li data-id="63" data-isShow="1">
                <img src={partners.JumpCryptoPng} alt="Jump Crypto" />
              </li>
              <li data-id="64" data-isShow="1">
                <img src={partners.KadoPng} alt="Kado" />
              </li>
              <li data-id="65" data-isShow="1">
                <img src={partners.KanaLabsPng} alt="Kana Labs" />
              </li>
              <li data-id="66" data-isShow="0">
                <img src={partners.KorbitPng} alt="Korbit" />
              </li>
              <li data-id="67" data-isShow="1">
                <img
                  src={partners.KRYPTOVENTURESLTDPng}
                  alt="KRYPTO VENTURES LTD"
                />
              </li>
              <li data-id="68" data-isShow="1">
                <img src={partners.LayerZeroPng} alt="Layer Zero" />
              </li>
              <li data-id="69" data-isShow="1">
                <img src={partners.LeapWalletPng} alt="Leap Wallet" />
              </li>
              <li data-id="70" data-isShow="0">
                <img src={partners.LucidefiPng} alt="Lucidefi" />
              </li>
            </ul>
          </Marquee>
        </div>

        <div className="partners-list">
          <Marquee style={{ overflowY: 'hidden' }}>
            <ul>
              <li data-id="71" data-isShow="1">
                <img src={partners.LydiaLabsPng} alt="Lydia Labs" />
              </li>
              <li data-id="72" data-isShow="1">
                <img src={partners.MblockPng} alt="Mblock" />
              </li>
              <li data-id="73" data-isShow="1">
                <img src={partners.MCFPng} alt="MCF" />
              </li>
              <li data-id="74" data-isShow="1">
                <img src={partners.MEVersePng} alt="MEVerse" />
              </li>
              <li data-id="75" data-isShow="0">
                <img src={partners.MEXCPng} alt="MEXC" />
              </li>
              <li data-id="76" data-isShow="1">
                <img src={partners.SevenlineLabsPng} alt="Sevenline Labs" />
              </li>
              <li data-id="77" data-isShow="1">
                <img src={partners.MoonletPng} alt="Moonlet" />
              </li>
              <li data-id="78" data-isShow="1">
                <img src={partners.NeftaPng} alt="Nefta" />
              </li>
              <li data-id="79" data-isShow="1">
                <img src={partners.OasysPng} alt="Oasys" />
              </li>
              <li data-id="80" data-isShow="1">
                <img src={partners.OLAGGPng} alt="OLA GG" />
              </li>
              <li data-id="81" data-isShow="0">
                <img src={partners.OsmosisPng} alt="Osmosis" />
              </li>
              <li data-id="82" data-isShow="1">
                <img src={partners.OZYSPng} alt="OZYS" />
              </li>
              <li data-id="83" data-isShow="1">
                <img src={partners.PARAMETAPng} alt="PARAMETA" />
              </li>
              <li data-id="84" data-isShow="1">
                <img src={partners.PerplayPng} alt="Perplay" />
              </li>
              <li data-id="85" data-isShow="1">
                <img
                  src={partners.PlayFutureFundLimitedPng}
                  alt="Play Future Fund Limited"
                />
              </li>
              <li data-id="86" data-isShow="1">
                <img src={partners.PrestoLabsPng} alt="Presto Labs" />
              </li>
              <li data-id="87" data-isShow="1">
                <img src={partners.PuzzlemonstersPng} alt="Puzzle monsters" />
              </li>
              <li data-id="88" data-isShow="1">
                <img src={partners.RottondaPng} alt="Rottonda" />
              </li>
              <li data-id="89" data-isShow="1">
                <img src={partners.RPGREPUBLICPng} alt="RPG REPUBLIC" />
              </li>
              <li data-id="90" data-isShow="1">
                <img src={partners.SKnetworksPng} alt="SK networks" />
              </li>
              <li data-id="91" data-isShow="1">
                <img
                  src={partners.SkyboundInteractiveLLCPng}
                  alt="Skybound Interactive, LLC"
                />
              </li>
              <li data-id="92" data-isShow="1">
                <img
                  src={partners.StakingFacilitiesPng}
                  alt="Staking Facilities"
                />
              </li>
              <li data-id="93" data-isShow="1">
                <img src={partners.StakingFundPng} alt="Staking Fund" />
              </li>
              <li data-id="94" data-isShow="1">
                <img src={partners.syncnodePng} alt="syncnode" />
              </li>
              <li data-id="95" data-isShow="1">
                <img src={partners.TIKITAKAstudioPng} alt="TIKITAKA studio" />
              </li>
              <li data-id="96" data-isShow="1">
                <img
                  src={partners.TRANSCENDFUNDIILPPng}
                  alt="TRANSCEND FUND II, LP"
                />
              </li>
              <li data-id="97" data-isShow="1">
                <img src={partners.TritonOnePng} alt="TritonOne" />
              </li>
              <li data-id="98" data-isShow="1">
                <img
                  src={partners.UnanimousCapitalPng}
                  alt="Unanimous Capital"
                />
              </li>
              <li data-id="99" data-isShow="1">
                <img src={partners.VenlyPng} alt="Venly" />
              </li>
              <li data-id="100" data-isShow="1">
                <img src={partners.WormholePng} alt="Wormhole" />
              </li>
              <li data-id="101" data-isShow="0">
                <img src={partners.XPLAFoundationPng} alt="XPLA Foundation" />
              </li>
              <li data-id="102" data-isShow="1">
                <img src={partners.XsollaPng} alt="Xsolla" />
              </li>
              <li data-id="103" data-isShow="1">
                <img src={partners.XterioPng} alt="Xterio" />
              </li>
              <li data-id="104" data-isShow="1">
                <img src={partners.YGGPng} alt="YGG" />
              </li>
              <li data-id="105" data-isShow="1">
                <img src={partners.ZenaADPng} alt="ZenaAD" />
              </li>
              <li data-id="106" data-isShow="0">
                <img
                  src={partners.TOEICOMPANYLTDPng}
                  alt="TOEI COMPANY, LTD."
                />
              </li>
              <li data-id="107" data-isShow="0">
                <img src={partners.StudioLuluLalaPng} alt="Studio LuluLala" />
              </li>
            </ul>
          </Marquee>
        </div>
      </div>
    </section>
  );
};

export default Partners;
